import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import SimpleButton from "../components/Buttons/SimpleButton";
import { NavBar } from "../components/NavBar";
import Text from "../components/Text/Text";
import { Timeline } from "../components/Timeline/Timeline";
import SongDTO from "../common/dto/SongDTO";
import { useAuth } from "../hooks/useAuth";
interface ListOptionsProps {
  theme: string;
  toggleTheme: () => void;
}
interface ListState {
  songDto: SongDTO;
  timelineEvents: Array<string>;
  quantity: number;
  masterCopy: boolean;
}

const ListOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #000D30;
  background-size: cover;
  width: 99vw;
  height: 100vh;
  justify-content: center;
  gap: 30px;
  align-items: center;
  position: relative;
`;

const SelectButton = styled(SimpleButton)`
  margin-top: 50px;
  border-radius: 10px;
  z-index: 1;
  align-self: center;
`;

const SingleColorTitle = styled("h2")<{ color: string }>`
  color: ${(props) => props.color};
  align-self: center;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-bottom: 10px;
`;

const BorderBox = styled("div")<{border: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 20%;
  min-height: 40%;
  padding-inline: 75px;
  background: #000D30;
  border: ${(props) => props.border};
  border-radius: 20px;
`;

export const ListOptionsPage: React.FC<ListOptionsProps> = ({
  theme,
  toggleTheme,
}) => {
  const { state } = useLocation();
  const locationState = state as ListState;
  const navigate = useNavigate();

  const onMintNowClick = () => {
    const songDto = locationState.songDto;
    if (locationState.masterCopy) {
      navigate("/minting_progress", { state: { songDto: songDto, timelineEvents: locationState.timelineEvents, listLater: false}});
    } else {
      navigate("/collectible_deploy", { state: { songDto: songDto, timelineEvents: locationState.timelineEvents, listLater: false, quantity: locationState.quantity} });

    }
  };

  const onListAtScheduledDateClick = () => {
      navigate("/set_launch_page", { state: { songDto: locationState.songDto, 
        timelineEvents: locationState.timelineEvents, quantity: locationState.quantity, masterCopy: locationState.masterCopy} });

  };

  const onListLaterClick = () => {
    navigate("/minting_progress", { state: { songDto: locationState.songDto, 
      timelineEvents: locationState.timelineEvents, listLater: true}});
  };

  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} hideNavLinks={true} />
      <ListOptionsContainer>
        <Timeline events={locationState.timelineEvents} currentEventIndex={locationState.masterCopy ? 3 : 2} 
        header={
          locationState.masterCopy ? "Creating Master Copy NFT": "Creating Collectible NFT"}
        />
        {locationState.masterCopy && <BorderBox border={"1px solid #28CBFF"}
        >
          <Content>
            <SingleColorTitle color="white">List Later</SingleColorTitle>
            <Text>
              Not ready to list on the marketplace yet? That's ok! Mint your NFT
              now and make it available to users later.
            </Text>
            <SelectButton onClick={onListLaterClick}>Select</SelectButton>
          </Content>
        </BorderBox>}
        <BorderBox
        border={"1px solid #B4BD7F"}
        >
          <Content>
            {locationState.masterCopy ? <SingleColorTitle color="white">Mint Now</SingleColorTitle> :
            <SingleColorTitle color="white">List Now</SingleColorTitle>}
            <Text>
              Your NFT will instantly be available for purchase on the marketplace.
            </Text>
            <SelectButton onClick={onMintNowClick}>Select</SelectButton>
          </Content>
        </BorderBox>
        <BorderBox border={"1px solid #9D7CFF"}>
          <Content>
            <SingleColorTitle color="white">
              List at Scheduled Date
            </SingleColorTitle>
            <Text>
              Your NFT will NOT be listed on the marketplace immediately. Set a
              launch date, let your fans know and let the hype commence.
            </Text>
            <SelectButton onClick={onListAtScheduledDateClick}>
              Select
            </SelectButton>
          </Content>
        </BorderBox>
      </ListOptionsContainer>
    </>
  );
};
